import Body from '../body/Body';
import Entry from './entry/Entry';
import Scroller from './scroller/Scroller';
import { $leaderBoard } from '../../../../backend/store/leaderBoard';

export default class Board extends Phaser.GameObjects.Container {
    private entries: Entry[] = [];
    private content!: Phaser.GameObjects.Container;
    private scroller!: Scroller;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.entries = [];

        this.setupEntries();
        this.setupScroller();
    }

    setupEntries() {
        this.content = this.scene.add.container(0, 0);
        this.add(this.content);
        const data = $leaderBoard.getState();

        for (let i = 0; i < data.length; i++) {
            let x = 0;
            let y = i * Entry.HEIGHT;
            const config: any = {
                ...data[i],
                place: i + 1,
            };

            let entry = new Entry(this.scene, x, y, config);
            // this.add(entry);
            this.content.add(entry);

            this.entries.push(entry);
        }
    }

    setupScroller() {
        let x = 0;
        let y = -Entry.HEIGHT / 2;

        this.scroller = new Scroller(this.scene, x, y);
        this.add(this.scroller);

        this.scroller.on('moved', this.onScrollerMoved, this);
    }

    onScrollerMoved(deltaY: number) {
        let minY = -Entry.HEIGHT * this.entries.length + Body.MASK.HEIGHT;
        let maxY = 0;

        this.content.y = Phaser.Math.Clamp(this.content.y + deltaY, minY, maxY);
    }
}
